import { Head, Link, usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Header } from "@/components/header"
import { SampleCard } from "@/components/sample-card"
import { SampleFilters } from "@/components/sample-filters"
import { Pagination } from "@/components/pagination"
import type Sample from "@/types/generated/Sample"
import type { SharedProps, Pagination as PaginationType, Filters, TagOption } from "@/types"

type Props = {
  samples: Sample[]
  pagination: PaginationType
  filters: Filters
  available_keys: string[]
  popular_tags: TagOption[]
}

export default function Index({ samples, pagination, filters, available_keys, popular_tags }: Props) {
  const { currentUser } = usePage<SharedProps>().props

  return (
    <div className="min-h-screen">
      <Head title="Samples" />
      <Header />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-2xl font-mono font-bold mb-6">SAMPLES</h1>

          <SampleFilters
            filters={filters}
            availableKeys={available_keys}
            popularTags={popular_tags}
          />

          {samples.length === 0 ? (
            <div className="text-center py-12 text-muted-foreground">
              <p>No samples found.</p>
              {!filters.q && !filters.key && !filters.bpm_min && currentUser && (
                <Button asChild className="mt-4">
                  <Link href="/samples/new">Upload the first one</Link>
                </Button>
              )}
            </div>
          ) : (
            <>
              <div className="flex flex-col gap-4">
                {samples.map((sample) => (
                  <SampleCard key={sample.id} sample={sample} />
                ))}
              </div>

              <Pagination pagination={pagination} />
            </>
          )}
        </div>
      </main>
    </div>
  )
}
